import Specialty from './Specialty'

export default class Neuroradiology extends Specialty {
  static entity = 'neuroradiology'
  static baseEntity = 'specialties'

  static fields() {
    return {
      ...super.fields()
    }
  }
}
